import auth from './auth'
import benefits from './benefits'
import coach from './coach'
import club from './club'
import common from './common'
import constant from './constant'
import event from './event'
import home from './home'
import performance from './performance'
import player from './player'
import terms from './terms'
import user from './user'

const locale = {
  translation: {
    common,
    event,
    club,
    performance,
    player,
    user,
    home,
    terms,
    auth,
    constant,
    benefits,
    coach,
  },
}

export default locale

export type Locale = typeof locale
